import React from 'react';

import { IIconProps } from './constants';

export const LinkIcon = ({ height = 24, width = 24 }: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.1404C10.3955 13.6728 10.9001 14.1134 11.4796 14.4322C12.0591 14.7511 12.6999 14.9407 13.3586 14.9882C14.0172 15.0357 14.6783 14.94 15.297 14.7076C15.9157 14.4751 16.4775 14.1115 16.9443 13.6412L19.7073 10.8588C20.5462 9.98423 21.0103 8.81284 20.9998 7.59697C20.9893 6.38109 20.505 5.21801 19.6512 4.35822C18.7974 3.49844 17.6424 3.01074 16.435 3.00018C15.2276 2.98961 14.0644 3.45702 13.1959 4.30173L11.6117 5.88768"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10.8596C13.6045 10.3272 13.0999 9.88658 12.5204 9.56776C11.9409 9.24894 11.3001 9.05935 10.6414 9.01185C9.98279 8.96435 9.32171 9.06004 8.70302 9.29245C8.08433 9.52486 7.52251 9.88853 7.05567 10.3588L4.29268 13.1412C3.45384 14.0158 2.98968 15.1872 3.00017 16.403C3.01067 17.6189 3.49497 18.782 4.34877 19.6418C5.20257 20.5016 6.35756 20.9893 7.56498 20.9998C8.77239 21.0104 9.93562 20.543 10.8041 19.6983L12.379 18.1123"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
